import * as t from 'io-ts';

export const PaginationInfo = t.type({
  offset: t.number,
  limit: t.number,
  total: t.number,
});
export type PaginationInfo = t.TypeOf<typeof PaginationInfo>;
